export default function calcArrow() {
  oneArrowInit();
  twoArrowInit();

  window.addEventListener("resize", oneArrowInit);
  window.addEventListener("resize", twoArrowInit);

  function oneArrowInit() {
    if (document.documentElement.clientWidth <= 768) {
      const arrow = document.querySelector("#arrow_one");
      const steps = document.querySelectorAll("[data-arrow-one-step]");
      let arrow_height = 176; // 180 - отступы

      steps.forEach((step) => (arrow_height += step.clientHeight));

      arrow.style.height = arrow_height + "px";
    } else {
      arrow.style.height = null;
    }
  }

  function twoArrowInit() {
    if (document.documentElement.clientWidth <= 768) {
      const arrow = document.querySelector("#arrow_two");
      const steps = document.querySelectorAll("[data-arrow-two-step]");
      let arrow_height = 92; // 92 - отступы

      steps.forEach((step) => (arrow_height += step.clientHeight));

      arrow.style.height = arrow_height + "px";
    } else {
      arrow.style.height = null;
    }
  }
}
